/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Foreignuniqualification2Inputs */

const en__field_foreignuniqualification2 = /** @type {(inputs: _Field_Foreignuniqualification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I gained my higher education entrance qualification (high school diploma or equivalent) outside of Germany`)
};

const de__field_foreignuniqualification2 = /** @type {(inputs: _Field_Foreignuniqualification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich habe meine Hochschulzugangsberechtigung (höchster Schulabschluss) außerhalb Deutschlands erworben`)
};

/**
* | output |
* | --- |
* | "I gained my higher education entrance qualification (high school diploma or equivalent) outside of Germany" |
*
* @param {_Field_Foreignuniqualification2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_foreignuniqualification2 = /** @type {((inputs?: _Field_Foreignuniqualification2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Foreignuniqualification2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_foreignuniqualification2(inputs)
	return de__field_foreignuniqualification2(inputs)
});
export { _field_foreignuniqualification2 as "_field_foreignUniQualification" }